const content = {
    steam_purchases: {
        en: {
            summary_html: '',
        summary_no_video_html: `
            <p>This Retro is all about your purchases and game play via Steam. Its easy to complete and will just take 2 mins.</p>
            <p>
                Tap on the following option that applies to you.
            </p>`,
        multiple_steps: [
            {
                title: 'I have the Steam app installed',
                steps: [
                    {
                        step_type: 'numbered_step',
                        number: '1',
                        description_html: '<p>Open the <b>Steam app</b> and log in.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '2',
                        description_html: '<p>Start the screen recording.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '3',
                        description_html: `Click on your <b>Profile</b> (top right corner).</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '4',
                        description_html: `Click <b>Store</b>, then cick <b>Account Details</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '5',
                        description_html: `<p>Then click <b>View Purchase History</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '6',
                        description_html: `<p>Scroll down the list of purchases.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '7',
                        description_html: `<p>Then go back to the menu and click <b>Library</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '8',
                        description_html: `<p>Scroll down the full list.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '9',
                        description_html: `<p>Then go back to the menu one last time and click <b>You & Friends</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '10',
                        description_html: `<p>Click <b>Profile</b>. Scroll to the bottom of the screen.</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '11',
                        description_html: `<p>Stop the screen recording and upload.</p>`
                    },
                ]
            },
            {
                title: 'I do NOT have the Steam app installed',
                steps: [
                    {
                        step_type: 'numbered_step',
                        number: '1',
                        description_html: '<p>Click this link: <a href="https://help.steampowered.com/en/accountdata" target="_blank">Steam</a>. Start the screen recording.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '2',
                        description_html: '<p>Sign in to your Steam account.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '3',
                        description_html: `In the Account Section - go to <b>Purchase History</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '4',
                        description_html: `Scroll down to the bottom of this list.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '5',
                        description_html: `<p>Go back to the main menu.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '6',
                        description_html: `<p>Click on <b>Steamworks Game Data</b> section - then click <b>All Games, Playtime, and Personal Game Data</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '7',
                        description_html: `<p>Scroll down the list from top to bottom.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '8',
                        description_html: `<p>Now select the 1st title on the list - and scroll down the screen.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '9',
                        description_html: `<p>Do this step for each title in your list.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '10',
                        description_html: `<p>Go back to the main menu and select <b>Community & Profile</b> Then click <b>Your Profile</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '11',
                        description_html: `<p>Scroll from top to bottom.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '12',
                        description_html: `<p>Stop the screen recording and upload.</p>`
                    },
                ],
            }
        ],
        }
    }
};

export const valveDataTypes = {
    steam_purchases: {
        data_type: 'steam_purchases',
        data_type_description: 'Steam Purchases',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/steam/steam_logo_2.jpeg',
        capture_type: 'video',
        ios: {
            use_in_app_screen_recorder: false,
            ...content.steam_purchases,
        },
        android: {
            use_in_app_screen_recorder: true,
            ...content.steam_purchases,
        }
    },
}